export enum MapLayer {
  ATKIS_PATHS = 'ATKIS_PATHS',
  ATKIS_STREETS = 'ATKIS_STREETS',
}
